import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";

/**
 * Redux holds client/session state only (the logged-in user, token, role,
 * company and branch). All server data — employees, leave, master data,
 * settings — is fetched and cached with TanStack Query (see src/api/queries).
 */
export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});
